import { UserRoleType } from '~/enums/UserRoleType';

import { testHasRole } from './utils/testHasRole';

export const checkIsWorkflowOnly = testHasRole(UserRoleType.WorkflowOnly);
